/**
 * Browser helper: start growth through the checked server endpoint.
 * Accounts can no longer be switched on by a direct Supabase write (the accounts
 * trigger refuses it); /api/account/start-growth re-checks the subscription first.
 */
export async function requestStartGrowth(accountId: string): Promise<{ ok: boolean; message?: string }> {
    try {
        const res = await fetch("/api/account/start-growth", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ accountId }),
        })
        if (res.ok) return { ok: true }
        const body = await res.json().catch(() => null)
        return { ok: false, message: (body && typeof body.error === "string" && body.error) || "Failed to start growth. Please try again." }
    } catch {
        return { ok: false, message: "Failed to start growth. Please try again." }
    }
}

/**
 * Browser helper: pause growth through the server so the pause is recorded (billing_events `growth_paused`).
 * Resolves with the updated account row (what the Supabase update used to return); throws on failure so the
 * account mutation rolls back its optimistic update exactly as before.
 */
export async function requestPauseGrowth(accountId: string): Promise<any> {
    const res = await fetch("/api/account/pause-growth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accountId }),
    })
    const body = await res.json().catch(() => null)
    if (!res.ok || !body?.account) throw new Error((body && typeof body.error === "string" && body.error) || "Failed to pause growth")
    return body.account
}
